import { TrainingPhraseConfig, TrainingPhraseOwnerType, TrainingPhraseType } from '@interface/training-phrase';
import * as React from 'react';
import { NiForm, NiModal, NiTable, TrainingPhraseComp } from '..';
import { localizedString } from '@locale/locale';
import { attributeToParameter, getAgentId, isStructAgent } from '@lib/quick-func';
import { ParameterMapStore } from '@lib/parameter-map';
import { Attribute } from '@interface/parameter';
import { cloneDeep } from 'lodash';


interface ValueExpressionTableRow {
  label: string;
  expressions: TrainingPhraseConfig[];
}

function valueExpressionTable({
  disabled,
  frameId,
  ownerId,
  data,
  labels,
  selectedParameters,
  onChange,
}: {
  disabled?: boolean;
  frameId: string;
  ownerId: string;
  labels: string[],
  selectedParameters: Attribute[];
  data: TrainingPhraseConfig[];
  onChange: (next: TrainingPhraseConfig[], oriData: TrainingPhraseConfig[]) => void;
}) {

  const [modalLabel, setModalLabel] = React.useState<string | undefined>();
  const [modalData, setModalData] = React.useState<TrainingPhraseConfig[]>([]);

  return <>
    <NiTable
      columns={[{
        dataIndex: 'label',
        title: localizedString('common_label')
      },
      {
        key: 'expressions',
        dataIndex: 'expressions',
        title: localizedString('common_expressions'),
        render: (exps: TrainingPhraseConfig[]) =>
          exps.length
            ? `${exps[0].trainingPhrase} 「${exps.length}」`
            : 'No Data'
      }]}
      dataSource={(labels || []).map((label: string) => ({
        label,
        expressions: data.filter((item: TrainingPhraseConfig) => item.label === label)
      }))}
      rowKey="label"
      onRow={(row: ValueExpressionTableRow) => ({
        onClick: () => {
          setModalLabel(row.label);
          setModalData((data || []).filter((item: TrainingPhraseConfig) => item.label === row.label));
        }
      })}
      pagination={false}
    />
    <NiModal
      title={localizedString('attribute_value_expressions')}
      open={!!modalLabel}
      onCancel={() => {
        setModalLabel(undefined);
        setModalData([]);
      }}
      onOk={() => {
        onChange([
          ...(data.filter((item: TrainingPhraseConfig) => item.label !== modalLabel)),
          ...modalData
        ], data);
        setModalLabel(undefined);
        setModalData([]);
      }}
    >
      <NiForm
        titleline
        direction="vertical"
        items={[{
          key: 'label',
          label: 'label',
          labelExtra: modalLabel
        }, {
          key: 'expressions',
          label: 'expressions',
          content: <TrainingPhraseComp
            disableChange={isStructAgent() || disabled}
            agentId={getAgentId()}
            frameId={frameId}
            ownerId={ownerId}
            label={modalLabel}
            ownerType={TrainingPhraseOwnerType.ATTRIBUTE}
            phraseType={TrainingPhraseType.SLOT_VALUE}
            isSingleLine={false}
            allowClearAll={true}
            data={modalData}
            parameterMap={ParameterMapStore.all()}
            parameters={selectedParameters.map(attributeToParameter)}
            update={(tps: TrainingPhraseConfig[]) => {
              setModalData(tps);
            }}
          />
        }]}
      />
    </NiModal>
  </>;
}

export const ValueExpressionTable = valueExpressionTable;

export default ValueExpressionTable;
